import SimpleCrudList from "../../components/crud/SimpleCrudList";

interface FlashSale {
  id: string;
  name: string;
  discountPercent: number;
  status: boolean;
}

export default function FlashSales() {
  return (
    <SimpleCrudList<FlashSale>
      title="Flash Sales"
      apiPath="/flash-sales"
      baseRoute="/flash-sales"
      searchKeys={["name"]}
      columns={[
        { key: "name", label: "Name" },
        { key: "discountPercent", label: "Discount %", render: (r) => `${r.discountPercent}%` },
        { key: "status", label: "Active", render: (r) => (r.status ? "Yes" : "No") },
      ]}
    />
  );
}
